export default function EmptyState({
  title,
  hint,
}: {
  title: string;
  hint?: string;
}) {
  return (
    <div className="text-center py-12 text-muted">
      <div className="text-base font-medium text-ink">{title}</div>
      {hint && <div className="text-sm mt-2">{hint}</div>}
    </div>
  );
}
